import { apiRequest } from './client'
import type { AuthOptions, User } from './types'

export const fetchAuthOptions = () => apiRequest<AuthOptions>('GET', '/api/auth/options')

export const signup = (input: {
  email: string
  name: string
  password: string
  inviteToken?: string
  /** Signing up from an app's connect page (a trusted app may bring people in while signup is invite-only). */
  oauthClientId?: string
  /** Where the verification link brings the person back to. */
  returnTo?: string
}) => apiRequest<{ user?: User; needsVerification?: boolean }>('POST', '/api/auth/signup', input)

export const verifyEmail = (token: string) => apiRequest<{ user: User }>('POST', '/api/auth/verify-email', { token })

export const resendVerification = (email: string) => apiRequest('POST', '/api/auth/resend-verification', { email })

export const login = (input: { email: string; password: string }) =>
  apiRequest<{ user: User }>('POST', '/api/auth/login', input)

export const logout = () => apiRequest('POST', '/api/auth/logout')

export const logoutEverywhere = () => apiRequest('POST', '/api/auth/logout-all')

export const forgotPassword = (email: string) => apiRequest('POST', '/api/auth/forgot-password', { email })

export const resetPassword = (input: { token: string; password: string }) =>
  apiRequest<{ user: User }>('POST', '/api/auth/reset-password', input)

/** A full-page navigation to Google; the platform sends the person back to `returnTo`. An invite token lets a new
 * account be created while sign-up is invite-only. */
export const googleStartUrl = (returnTo: string, invite?: string): string =>
  `/api/auth/google/start?${new URLSearchParams({ returnTo, ...(invite ? { invite } : {}) }).toString()}`

export const previewSignupInvite = (token: string) =>
  apiRequest<{ invite: { email: string; company: string | null; expiresAt: string } }>(
    'POST',
    '/api/auth/signup-invites/preview',
    { token },
  )
